<div class="my-badges">
  <div class="card">

    <div class="my-badges__container">
      <h2>Twoje odznaki</h2>

      <div class="my-badges__items" *ngIf="activities">
        <ng-container *ngFor="let activity of activities">
          <app-badge
            [activityData]="activity" [level]="activity.userActivityLevel"
            [showCaption]="true"
            [size]="5"></app-badge>
        </ng-container>

<!--        <figure class="badge-progress">-->
<!--          <div class="badge badge&#45;&#45;green badge-progress&#45;&#45;size-3 badge-progress&#45;&#45;fill-0">-->
<!--            <i class="icon-quizer"></i>-->
<!--          </div>-->
<!--          <figcaption class="badge-caption">0/3</figcaption>-->
<!--        </figure>-->

<!--        <figure class="badge-progress">-->
<!--          <div class="badge badge&#45;&#45;blue badge-progress&#45;&#45;size-3 badge-progress&#45;&#45;fill-1">-->
<!--            <i class="icon-bystrzak"></i>-->
<!--          </div>-->
<!--          <figcaption class="badge-caption">1/3</figcaption>-->
<!--        </figure>-->

<!--        <figure class="badge-progress">-->
<!--          <div class="badge badge&#45;&#45;purpule badge-progress&#45;&#45;size-4 badge-progress&#45;&#45;fill-0">-->
<!--            <i class="icon-ciekawski"></i>-->
<!--          </div>-->
<!--          <figcaption class="badge-caption">0/4</figcaption>-->
<!--        </figure>-->

<!--        <figure class="badge-progress">-->
<!--          <div class="badge badge&#45;&#45;pink badge-progress&#45;&#45;size-5 badge-progress&#45;&#45;fill-1">-->
<!--            <i class="icon-aktywista"></i>-->
<!--          </div>-->
<!--          <figcaption class="badge-caption">1/5</figcaption>-->
<!--        </figure>-->
      </div>

      <p>Postęp do następnej odznaki</p>

    </div>


  </div>
</div>
